import React from 'react';
export var SessionCalendarIcon = function SessionCalendarIcon(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 26 28"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 2.46567V1.4794C17.5 0.6608 18.17 0 19 0C19.83 0 20.5 0.6608 20.5 1.4794V2.46567H23C24.38 2.46567 25.5 3.57029 25.5 4.93135V24.6567C25.5 26.0178 24.38 27.1224 23 27.1224H3C1.62 27.1224 0.5 26.0178 0.5 24.6567V4.93135C0.5 3.57029 1.62 2.46567 3 2.46567H5.5V1.4794C5.5 0.6608 6.17 0 7 0C7.83 0 8.5 0.6608 8.5 1.4794V2.46567H17.5ZM22.5 11.3421H3.5V24.1636H22.5V11.3421ZM22.5 8.38329V5.42448H3.5V8.38329H22.5Z",
    fill: "#AA9B8C"
  }));
};